import { useState, useCallback, useMemo } from "react";
import { Popover } from "@mui/material";
import { isValidValue } from "utils";

const usePopper = (options = {}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = options?.id ?? "custom-popper";

  const openPopper = useCallback(
    (event) => {
      if (isValidValue(options?.openCondition) && !options?.openCondition) {
        return;
      }
      setAnchorEl(event.currentTarget);
    },
    [options]
  );

  const closePopper = useCallback(() => {
    setAnchorEl(null);
    options?.onClose?.();
  }, [options]);

  const handleChange = useCallback(
    (...args) => {
      options?.onChange?.(...args);
      if (options.closeOnChange) setAnchorEl(null);
    },
    [options]
  );

  const PopperWrapper = useMemo(() => {
    return ({ children }) => (
      <Popover
        elevation={0}
        slotProps={
          options.slotProps || {
            paper: {
              variant: "outlined",
            },
          }
        }
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={closePopper}
        anchorOrigin={
          options.anchorOrigin || { vertical: "bottom", horizontal: "center" }
        }
        transformOrigin={
          options.transformOrigin || { vertical: "top", horizontal: "center" }
        }
        sx={{ top: 4, ...(options.sx ?? {}) }}
        keepMounted
      >
        {children}
      </Popover>
    );
  }, [id, open, anchorEl, closePopper, options]);

  return {
    openPopper,
    closePopper,
    PopperWrapper,
    handleChange,
    open,
    id,
    anchorEl,
  };
};

export default usePopper;
